import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { useCookieConsent } from "@/context/CookieConsentContext";

export default function Footer() {
  const { t, lang } = useI18n();
  const { openBanner } = useCookieConsent();
  const base = `/${lang}`;
  const email = t("footer.address.email");

  return (
    <footer className="site-footer" id="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-brand-row">
            <span className="brand-mark" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="26" height="26" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="11" width="4" height="16" rx="1" fill="currentColor"/>
                <rect x="9" y="7" width="5" height="20" rx="1" fill="currentColor"/>
                <rect x="16" y="13" width="4" height="14" rx="1" fill="currentColor"/>
                <rect x="22" y="10" width="4" height="17" rx="1" fill="currentColor"/>
                <rect x="2" y="27" width="25" height="2" fill="currentColor"/>
              </svg>
            </span>
            <span className="footer-brand-name">Mirexilava</span>
          </div>
          <p className="footer-tag">{t("footer.tagline")}</p>
          <p className="footer-about">{t("footer.about")}</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t("footer.sections.navigate")}</h4>
          <ul>
            <li><Link to={base}>{t("nav.home")}</Link></li>
            <li><a href={`${base}#como-funciona`} onClick={(e) => { e.preventDefault(); const el = document.getElementById('como-funciona'); if (el) el.scrollIntoView({behavior:'smooth'}); else window.location.href = base + '#como-funciona'; }}>{t("nav.how")}</a></li>
            <li><a href={`${base}#proyectos`} onClick={(e) => { e.preventDefault(); const el = document.getElementById('proyectos'); if (el) el.scrollIntoView({behavior:'smooth'}); else window.location.href = base + '#proyectos'; }}>{t("nav.projects")}</a></li>
            <li><a href={`${base}#nosotros`} onClick={(e) => { e.preventDefault(); const el = document.getElementById('nosotros'); if (el) el.scrollIntoView({behavior:'smooth'}); else window.location.href = base + '#nosotros'; }}>{t("nav.about")}</a></li>
            <li><a href={`${base}#contacto`} onClick={(e) => { e.preventDefault(); const el = document.getElementById('contacto'); if (el) el.scrollIntoView({behavior:'smooth'}); else window.location.href = base + '#contacto'; }}>{t("nav.contact")}</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t("footer.sections.legal")}</h4>
          <ul>
            <li><Link to={`${base}/privacy-policy`} data-testid="footer-privacy">{t("privacy.title")}</Link></li>
            <li><Link to={`${base}/cookie-policy`} data-testid="footer-cookies">{t("cookies.title")}</Link></li>
            <li><Link to={`${base}/terms-and-conditions`} data-testid="footer-terms">{t("terms.title")}</Link></li>
            <li>
              <button type="button" className="link-btn" onClick={openBanner} data-testid="footer-cookie-settings">
                {t("cookieBanner.manage")}
              </button>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t("footer.sections.office")}</h4>
          <address className="footer-address">
            <p><MapPin size={14} /> {t("footer.address.line1")}</p>
            <p>{t("footer.address.line2")}</p>
            <p>{t("footer.address.line3")}</p>
            <p><a href={`mailto:${email}`}><Mail size={14} /> {email}</a></p>
            <p><a href={`tel:${t("footer.address.phone").replace(/\s/g, "")}`}><Phone size={14} /> {t("footer.address.phone")}</a></p>
          </address>
        </div>
      </div>

      <div className="footer-legal">
        <p>{t("footer.legal.companyLine")}</p>
        <p>{t("footer.legal.registration")}</p>
        <p>{t("footer.legal.taxId")} · {t("footer.legal.license")}</p>
        <p>{t("footer.legal.jurisdiction")} · {t("footer.legal.incorporation")}</p>
        <p className="footer-disclaimer">{t("footer.disclaimer")}</p>
        <div className="footer-bottom">
          <span>{t("footer.legal.rights")}</span>
          <a href="https://mirexilava.com" className="footer-external" rel="noreferrer">mirexilava.com <ArrowUpRight size={12} /></a>
        </div>
      </div>
    </footer>
  );
}
